import React from 'react';
import { cn } from '../../lib/utils';

const IconTextButton = ({ 
  icon, // SVG icon component
  text, // Button text
  onClick, 
  className = '', 
  disabled = false,
  type = 'button',
  variant = 'default', // default, danger, success, warning
  size = 'md', // sm, md, lg
  style = {},
  ...props 
}) => {
  const sizeClasses = {
    sm: 'px-3 py-2 text-sm',
    md: 'px-4 py-3 text-lg',
    lg: 'px-6 py-4 text-xl'
  };

  const iconSizeClasses = {
    sm: 'w-5 h-5',
    md: 'w-7 h-7',
    lg: 'w-8 h-8'
  };

  const variantClasses = {
    default: 'bg-green-700 hover:bg-green-700',
    danger: 'bg-red-700 hover:bg-red-700',
    success: 'bg-green-700 hover:bg-green-700',
    warning: 'bg-yellow-700 hover:bg-yellow-700'
  };

  const textColorClasses = {
    default: '',
    danger: '',
    success: '',
    warning: ''
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={{
        color: '#ffffff',
        ...style
      }}
      className={cn(
        // Base styles
        'rounded-xl inline-flex justify-start items-center gap-3',
        'transition-all duration-300 ease-in-out',
        'font-normal font-[\'Open_Sans\'] leading-relaxed',
        // Size
        sizeClasses[size],
        // Variant colors
        variantClasses[variant],
        // Text color
        textColorClasses[variant],
        // Hover effects
        'hover:shadow-[0px_15px_30px_0px_rgba(0,0,0,0.10)]',
        'hover:shadow-[0px_5px_20.100000381469727px_0px_rgba(255,255,255,0.10)]',
        'hover:shadow-[inset_0px_4px_25px_0px_rgba(255,255,255,0.35)]',
        'hover:outline hover:outline-[0.86px] hover:outline-offset-[-0.86px] hover:outline-white',
        'hover:backdrop-blur-[30px]',
        // Disabled state
        'disabled:opacity-50 disabled:cursor-not-allowed',
        'disabled:hover:shadow-none disabled:hover:outline-none disabled:hover:backdrop-blur-none',
        // Custom className override
        className
      )}
      {...props}
    >
      {/* Icon */}
      <div className={cn(
        'relative overflow-hidden flex items-center justify-center',
        iconSizeClasses[size]
      )}>
        {icon || (
          <div className={cn(
            'bg-white',
            size === 'sm' ? 'w-3 h-3' : size === 'md' ? 'w-4 h-4' : 'w-5 h-5',
            size === 'sm' ? 'left-[3px] top-[3px]' : size === 'md' ? 'left-[5.62px] top-[5.63px]' : 'left-[6px] top-[6px]'
          )} />
        )}
      </div>
      
      {/* Text */}
      <div className="justify-center" style={{ color: '#ffffff !important' }}>
        <span className="icon-text-button-text" style={{ 
          color: '#ffffff !important',
          WebkitTextFillColor: '#ffffff !important',
          WebkitTextStroke: 'none !important'
        }}>
          {text || 'Button Text'}
        </span>
      </div>
    </button>
  );
};

export default IconTextButton;
